export const SELECT_CLASS_NAME_PREFIX = 'sol-react-select';
